/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { ErrorHoldersConfig } from '../../config/error.config';
export interface IErrorHoldersPluginMethods extends IPluginMethodMap {
  getErrorHoldersSync(args?: any): any;
}

export class ErrorHoldersPlugin implements IAgentPlugin {
  readonly methods: IErrorHoldersPluginMethods;

  constructor() {
    this.methods = {
      getErrorHoldersSync: this.getErrorHoldersSync.bind(this),
    };
  }

  getErrorHoldersSync(args?: any) {
    return {
      error: ErrorHoldersConfig,
    };
  }
}
